// extracted by mini-css-extract-plugin
export default {"root":"TagsMenu_root__rNRy4","rootVisible":"TagsMenu_rootVisible__uaSzU","bottom":"TagsMenu_bottom__9NyHK","top":"TagsMenu_top__M91pL","removeOption":"TagsMenu_removeOption__1X-p1"};